import { render, staticRenderFns } from "./VInternalTimeStats.vue?vue&type=template&id=1db9dd18&"
import script from "./VInternalTimeStats.vue?vue&type=script&lang=js&"
export * from "./VInternalTimeStats.vue?vue&type=script&lang=js&"
import style0 from "./VInternalTimeStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports